// ReceiverTopbar.jsx
import React from 'react';
import { Navbar, Container, Nav, Dropdown } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import '../../assets/css/receiverdashboard/ReceiverTopBar.css';

const ReceiverTopbar = () => {
  const navigate = useNavigate();

  return (
    <Navbar className="receiver-topbar" expand="lg">
      <Container fluid>
        {/* Left Side - Logo */}
        <Navbar.Brand className="topbar-brand" onClick={() => navigate('/receiver/dashboard')}>
          <div className="brand-logo-wrapper">
            <div className="logo-icon">SDMS</div>
            <div className="logo-glow"></div>
          </div>
        </Navbar.Brand>

        {/* Mobile Toggle */}
        <Navbar.Toggle aria-controls="topbar-nav" className="mobile-toggle">
          <i className="bi bi-list"></i>
        </Navbar.Toggle>

        <Navbar.Collapse id="topbar-nav">
          <Nav className="ms-auto align-items-center">
            {/* User Profile - same button/style as before, dropdown menu removed */}
             <Dropdown className="profile-dropdown">
              <Dropdown.Toggle className="profile-btn" id="profile-dropdown">
                <div className="profile-avatar">
                  <span className="avatar-text">MI</span>
                  <div className="status-dot"></div>
                </div>
                <div className="profile-info">
                  <div className="profile-name">M Imran</div>
                  <div className="profile-role">Receiver</div>
                </div>
                {/* <i className="bi bi-chevron-down ms-2"></i> */}
              </Dropdown.Toggle>
            </Dropdown> 
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default ReceiverTopbar;